// YERİ: src/app/domains/website/sections/mkt-link.ts
// Vitrindeki her bağlantı buradan geçer.
//
// CMS'te bağlantılar DİLSİZ yazılır ("pricing", "solutions/restaurant"). Dil
// önekini burada ekleriz — aksi hâlde editörün her dilde her linki elle
// düzeltmesi gerekirdi ve bir dil eklendiğinde tüm linkler bozulurdu.
//
// Kurallar:
//   "pricing"              → ['/', 'en', 'pricing']       (dil önekli)
//   "solutions/restaurant" → ['/', 'en', 'solutions', 'restaurant']
//   "/auth/sign-up"        → '/auth/sign-up'              (mutlak — panele gider)
//   "https://…"            → dış URL, olduğu gibi
//   ""                     → ana sayfa
//   "services#branding"    → ['/', 'en', 'services'] + fragment 'branding'
//
// ÇIPA (#) DESTEĞİ: routerLink yol parçalarını URL-encode eder, yani '#' bir
// yol parçası olarak '%23' olur ve 404 döner (bu bir kez oldu). Fragment
// AYRI verilmek zorunda: [routerLink]="link(url)" [fragment]="fragment(url)".

import { computed, inject, Signal } from '@angular/core';
import { LanguageStore } from '../core/language.store';

export type MktRouterLink = unknown[] | string;

/**
 * routerLink için hazır bir signal üretir. Bölümlerin alan başlatıcısında
 * çağrılır, o yüzden inject() bağlamı geçerlidir.
 */
export function mktLink(url: () => string): Signal<MktRouterLink> {
  const langStore = inject(LanguageStore);

  return computed(() => resolveMktLink(url(), langStore.current()));
}

export function resolveMktLink(url: string, lang: string): MktRouterLink {
  const value = (url ?? '').trim();

  if (!value) return ['/', lang];
  // Dış bağlantı — routerLink bunu href gibi kullanır.
  if (/^https?:\/\/|^mailto:|^tel:/i.test(value)) return value;
  // Mutlak yol: vitrinin dışına (panel, giriş) çıkar, dil öneki ALMAZ.
  if (value.startsWith('/')) return value;

  const path = value.split('#')[0];
  return ['/', lang, ...path.split('/').filter(Boolean)];
}

/** Bağlantının '#'ten sonraki kısmı — yoksa undefined (routerLink'e verilebilir). */
export function resolveMktFragment(url: string): string | undefined {
  const hash = (url ?? '').split('#')[1];
  return hash ? hash.trim() : undefined;
}
